import React from 'react';
import { CustomTextField, InputProps } from './componentsnew';

const InputTextField = ({
  label,
  value,
  onChange,
  type = 'text',
  variant = 'standard',
  error = false,
  disabled = false,
  fullWidth = true,
  placeholder,
  inputProps,
  sx,
  className,
  ...props
}) => {
  const labelText = typeof label === 'string' ? label.toLowerCase() : 'value';

  return (
    <CustomTextField
      {...InputProps}
      fullWidth={fullWidth}
      variant={variant}
      error={error}
      disabled={disabled}
      label={label}
      placeholder={placeholder || `Enter ${labelText}`}
      type={type}
      value={value ?? ''}
      onChange={onChange || (() => {})}
      sx={sx}
      className={className}
      inputProps={inputProps}
      {...props}
    />
  );
};

export default InputTextField;
